import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { SarsModel } from "../../../../domain/SarsModel";
import { createFoi } from "../../../../redux/actions";
import { createItemSelector } from "../../../../redux/selectors";

export const CreateFoiDialog: React.FC<{ item: SarsModel }> = ({ item }) => {
  const dispatch = useDispatch();
  const onSubmit = (data: SarsModel) => {
    dispatch(createFoi(data.id));
  };

  const { status } = useSelector(createItemSelector);
  return (
    <form>
      <DialogTitle>
        Transfer this SAR to a FOI
        <Divider />
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">
          Are you sure you want to transfer this SAR to a FOI?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onSubmit(item)}
          color="primary"
          data-test="confirm-transfer-button"
          disabled={status === "CREATING"}
        >
          Confirm
        </Button>
      </DialogActions>
    </form>
  );
};
